import {RouterPaths} from "../routerPaths";
import {importPages} from "../lazyRoute";

const administrationRoutes = [
    {
        path: RouterPaths.ROLE,
        element: importPages.Role,
    },
    {
        path: RouterPaths.PERMISSIONS,
        element: importPages.Permissions,
    },


    {
        path: RouterPaths.EDUCATIONALSETTINGS,
        element:importPages.EducationalSettings
    },


    {
        path: RouterPaths.INSTITUTESETTINGS,
        element:importPages.InstituteSettings
    },
    {
        path: RouterPaths.EDUACTIONALINSTITUTE,
        element: importPages.EducationalInstitution,
    },
    {
        path: RouterPaths.USERACCESSCONTROL,
        element: importPages.UserAccessControl,
    },
    {
        path: RouterPaths.EXPIREALLPASSWORDS,
        element: importPages.ExpireAllPasswords,
    },
    {
        path: RouterPaths.ACTIONHISTORY,
        element: importPages.ActionHistory,
    },
    {
        path: RouterPaths.EXPIREALLPASSWORD,
        element: importPages.ExpireAllPassword,
    },
]
export default administrationRoutes